import script from "./FISearch.vue?vue&type=script&setup=true&lang=ts"
export * from "./FISearch.vue?vue&type=script&setup=true&lang=ts"

import "./FISearch.vue?vue&type=style&index=0&id=7bbb9fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bbb9fbc"]])

export default __exports__